<template>
  <form>
    <input type="hidden" name="slug" :value="slug"/>
    <input type="hidden" :name="pageKey" :value="page"/>
    <div class="form-row align-items-center">
      <div class="col-auto" v-if="showFields('ratingStart')">
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text">
              <font-awesome-icon icon="star"/>
            </div>
          </div>
          <select v-model="ratingStartValue" name="ratingStart" class="form-control">
            <option value="">所有評分</option>
            <option :value="item" v-for="(item, key) in [1, 2, 3, 4, 5]" :key="key">{{ item }}星</option>
          </select>
        </div>
      </div>
      <div class="col-auto" v-if="showFields('purchaseVerify')">
        <input type="hidden" name="slug" :value="slug"/>
        <input type="hidden" :name="pageKey" :value="page"/>
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text">
              <font-awesome-icon icon="money-check-alt"/>
            </div>
          </div>
          <select v-model="purchaseVerifyValue" name="purchaseVerify" class="form-control">
            <option value="">所有評論者</option>
            <option value="1">僅驗證購買者</option>
          </select>
        </div>
      </div>
      <div class="col-auto" v-if="showFields('hasPic')">
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text">
              <font-awesome-icon icon="image"/>
            </div>
          </div>
          <select v-model="hasPicValue" class="form-control" name="hasPic">
            <option value="">所有評價</option>
            <option value="1">有圖片</option>
          </select>
        </div>
      </div>
      <!--  精選評價   -->
      <div class="col-auto" v-if="showFields('blueTick')">
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text">
              <v-icon color="success" size="17">
                mdi-shield-check
              </v-icon>
            </div>
          </div>
          <select v-model="blueTick" class="form-control" name="blueTick">
            <option value="">所有評價</option>
            <option value="1">精選評價</option>
          </select>
        </div>
      </div>
      <div class="col-auto" v-if="showFields('sort')">
        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <div class="input-group-text">
              <font-awesome-icon icon="sort-amount-down"/>
              <p>排序</p></div>
          </div>
          <select v-model="sortValue" class="form-control" name="sort">
            <option :value="item.value" v-for="item in sortList">{{ item.text }}</option>
          </select>
        </div>
      </div>
      <div class="col-auto">
        <InputSuggestion ref="inputSuggestion"
                         v-if="showFields('suggestion')"
        ></InputSuggestion>
      </div>
      <div class="col-auto">
        <div class="input-group mb-2">
          <div class="input-group-prepend" v-if="!showFields('suggestion')">
            <div class="input-group-text">
              <font-awesome-icon icon="search"/>
            </div>
          </div>
          <button type="button" class="searchBtn" @click="postSearch">搜尋</button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import InputSuggestion from 'Vue/Web/Plugins/InputSuggestion.vue';

export default {
  name: 'RatingSearch',
  components: { InputSuggestion },
  props: {
    slug: {
      type: String,
      default: '',
    },
    page: {
      type: String,
      default: '',
    },
    pageKey: {
      type: String,
      default: '',
    },
    filterFieldsVisible: {
      type: Array,
      default() {
        return ['ratingStart', 'purchaseVerify', 'hasPic', 'sort'];
      },
    },
    sortList: {
      type: Array,
      default() {
        return [
          {
            text: '最新',
            value: 'new'
          },
          {
            text: '評價最高',
            value: 'height'
          },
        ];
      },
    },
    pageType: {
      type: String,
      default: '',
    },
    urlKey: {
      type: String,
      default: '',
    },
    scrollToElement: {
      type: String,
      default: 'ratingBox',
    },
  },
  data() {
    return {
      hasPicValue: '',
      purchaseVerifyValue: '',
      ratingStartValue: '',
      sortValue: '',
      blueTick: '',
      paramKeyword: '',
      headerHeight: 0,
      optionBarHeight: 0,
      stickyBarHeight: 0,
    };
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    this.hasPicValue = urlParams.get('hasPic') || '';
    this.purchaseVerifyValue = urlParams.get('purchaseVerify') || '';
    this.ratingStartValue = urlParams.get('ratingStart') || '';

    // 檢查 sortValue 是否在 sortList 中
    const sortValue = urlParams.get('sort');
    const validValues = this.sortList.map((item) => item.value);
    this.sortValue = validValues.includes(sortValue) ? sortValue : 'blueTick';

    this.blueTick = urlParams.get('blueTick') || '';

    // 檢查網址中是否有你想要的參數，假設參數名稱是 pageKey
    if (urlParams.has('scrollTo')) {
      const targetClass = this.scrollToElement;
      const elements = document.getElementsByClassName(targetClass);
      // 如果動態載入後才會出現元素，使用 MutationObserver 來監聽 DOM 變化
      const observer = new MutationObserver(() => {
        const targetElement = document.querySelector(`.${targetClass}`);
        if (targetElement) {
          // 偵測到目標元素後停止觀察
          observer.disconnect();

          // 滾動到該元素
          targetElement.scrollIntoView({
            block: 'start',
            inline: 'nearest',
          });

          // 設定額外的 scroll 調整，避免偏移
          window.scroll({
            top: targetElement.offsetTop + 100,
            behavior: 'smooth',// 滾動行為可以設置為 'smooth' 或 'auto'
          });
        }
      });

      // 監聽整個 document 的子樹變動（包括動態載入的內容）
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });

      // 如果初始載入時已經有目標元素，則馬上進行滾動
      if (elements.length > 0) {
        elements[0].scrollIntoView({
          block: 'start',
          inline: 'nearest',
        });
        window.scroll({
          top: elements[0].offsetTop + 100,
          behavior: 'auto',
        });
      }
    }
  },
  beforeDestroy() {
  },
  methods: {
    showFields(type) {
      return this.filterFieldsVisible.includes(type);
    },
    postSearch() {
      global.Message.show('正在為您搜尋...', 20);

      // 1. 創建一個代表你評價的對象
      const reviewParams = {
        hasPic: this.hasPicValue,
        purchaseVerify: this.purchaseVerifyValue,
        ratingStart: this.ratingStartValue,
        sort: this.sortValue,
        blueTick: this.blueTick,
        scrollTo: 1,
      };

      if (this.showFields('suggestion')) {
        reviewParams.keyword = this.$refs.inputSuggestion.syncKeyword();
      }

      // reviewParams[this.urlKey] = this.urlKey;

      // // 2. 把評價參數轉換成一個巢狀的JSON字串，並編碼它
      // const encodedReview = encodeURIComponent(JSON.stringify(reviewParams));
      //
      // // 3. 創建其餘的URL參數
      // const otherParams = {
      //   [this.pageKey]: this.page,
      //   scrollTo: this.urlKey,
      //   [this.urlKey]: encodedReview  // 使用 this.urlKey 作為key
      // };

      const query = Object.entries(reviewParams)
          // eslint-disable-next-line no-unused-vars
          .filter(([key, value]) => value !== null && value !== '')
          .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
          .join('&');

      window.location.href = `/${this.pageType}/${this.slug}?${query}`;
    }
  }
};
</script>

<style scoped lang="scss">

.sticky-element {
  z-index: 9;
  transition: width 0.5s ease;
}

.sticky-full-width {
  width: 100vh;
  background: white;
  padding-top: 5px;
  padding-bottom: 5px;
}

.searchBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 29px;
  color: white;
  background: #72ca4a;
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.2);
  border: none;
  font-size: 14px;
  border-radius: 5px;
}

.input-group-text {
  p {
    margin: 0;
    margin-left: 10px;
  }

  svg {
    color: #72ca4a;
    width: 1.5rem;
    height: auto;
  }
}
</style>
